export default __webpack_public_path__ + "static/media/gluelogo.dd6c32f7.png";